import type { Messages } from "./es";

const it = {
  // ── Comune ─────────────────────────────────────────────────────────
  commonPoweredBy: "Offerto da",
  commonManageReservationLink: "Gestisci la mia prenotazione",
  commonRestaurantConfirmAvailability:
    "Il ristorante confermerà la disponibilità.",
  commonConnectionErrorShort: "Errore di connessione",
  commonConnectionErrorRetry: "Errore di connessione. Riprova.",
  commonConnectionErrorLater: "Errore di connessione. Riprova più tardi.",
  commonPeopleOne: "{n} persona",
  commonPeopleOther: "{n} persone",
  commonPeopleShortOne: "{n} pers.",
  commonPeopleShortOther: "{n} pers.",
  commonCalendarWeekdays: ["L", "M", "M", "G", "V", "S", "D"],
  commonTimeSuffix: " h",

  commonMenuShowDescription: "Vedi descrizione",
  commonMenuHideDescription: "Nascondi descrizione",
  commonMenuAllGuestsLabel: "Per tutto il tavolo ({count} persone)",
  commonMenuTotalLabel: "Selezionato: {total} di {count} persone",
  commonMenuExceedsPartySize:
    "Il menu selezionato supera il numero di persone.",
  commonMenuSummaryItem: "{qty}× {name}",

  // ── App.tsx (prenotazione tavolo) ─────────────────────────────────────
  appOrgNotFoundHeading: "Ristorante non trovato",
  appOrgNotFoundFallback: "Ristorante non trovato",
  appOrgLoadNetworkError: "Errore nel caricamento dei dati del ristorante",
  appOrgLoadGenericError:
    "Non è stato possibile caricare le informazioni del ristorante",

  appSuccessHeadingLargeGroup: "Richiesta ricevuta!",
  appSuccessHeadingPending: "Richiesta inviata!",
  appSuccessHeadingConfirmed: "Prenotazione confermata!",
  appSuccessBodyLargeGroup:
    "La tua richiesta per un gruppo presso {name} è stata registrata. Il ristorante ti contatterà.",
  appSuccessBodyPending:
    "La tua prenotazione presso {name} è in attesa di approvazione. Ti avviseremo non appena il ristorante la confermerà.",
  appSuccessBodyConfirmed: "La tua prenotazione presso {name} è stata registrata.",
  appSuccessEmailNotePending: "Riceverai l'avviso di conferma a {email}",
  appSuccessEmailNoteConfirmed: "Riceverai un'email di conferma a {email}",
  appNewReservationButton: "Fai un'altra prenotazione",

  appPartySizeLabel: "Numero di persone",
  appLargeGroupButton: "Gruppo numeroso (+{threshold} persone)",
  appLargeGroupQuestion: "In quante persone siete?",
  appLargeGroupPlaceholder: "Es.: 25",

  appSelectDayLabel: "Seleziona il giorno",
  appShowMoreDates: "Vedi altre date",

  appSelectRoomLabel: "Seleziona la sala",
  appNoRoomsAvailable: "Nessuna sala disponibile per questo giorno.",

  appSelectTimeLabel: "Seleziona l'orario",
  appDefaultClosedReason: "Giorno di chiusura",
  appNoSlotsAvailable: "Nessun orario disponibile",
  appDefaultShiftLunch: "PRANZO",
  appDefaultShiftDinner: "CENA",
  appNoTablesAvailable: "Nessun tavolo disponibile",
  appContinueButton: "Continua",

  appMenuQuestionHeading: "Volete un menu?",
  appMenuNoThanksButton: "No, grazie",
  appMenuYesButton: "Sì",
  appMenuListHeading: "Scegli il tuo menu",
  appMenuSummaryHeading: "Il tuo menu:",

  appSummaryModify: "Modifica",
  appPhoneLabel: "Telefono *",
  appPhonePlaceholder: "312 345 6789",
  appNameLabel: "Nome *",
  appNamePlaceholder: "Il tuo nome",
  appLastNameLabel: "Cognome *",
  appLastNamePlaceholder: "Il tuo cognome",
  appEmailLabel: "Email *",
  appEmailPlaceholder: "tu@email.com",
  appEmailInvalid: "Inserisci un indirizzo email valido",
  appNotesLabel: "Commenti (facoltativo)",
  appNotesPlaceholderDefault:
    "Preferenze sul tavolo, compleanno, seggiolone, mobilità ridotta, ecc.",

  appAcceptTermsPrefix: "Accetto i",
  appTermsLinkLabel: "Termini e Condizioni",
  appAcceptPrivacyPrefix: "Accetto l'",
  appPrivacyLinkLabel: "Informativa sulla Privacy",
  appSpendNotice:
    "{restaurant} conserva l'importo del conto della tua prenotazione nella tua scheda cliente. Puoi opporti in qualsiasi momento. Maggiori informazioni:",
  appMarketingCheckbox: "Ricevere offerte e novità dal ristorante",

  appLargeGroupSummary: "Gruppo numeroso ({people})",

  appBackButton: "Indietro",
  appSubmitButton: "Prenota",
  appSubmitting: "Invio in corso...",
  appSubmitErrorFallback: "Errore nella creazione della prenotazione",

  appFullCalendarTitle: "Seleziona una data",

  // ── ReservationManage.tsx (gestire la prenotazione dal link) ─────────
  manageLoading: "Caricamento della tua prenotazione...",
  manageNotFoundHeading: "Prenotazione non trovata",
  manageFetchErrorFallback: "Prenotazione non trovata",
  manageConfirmErrorFallback: "Errore nella conferma",
  manageCancelErrorFallback: "Errore nella cancellazione",
  manageModifyErrorFallback: "Errore nella modifica della prenotazione",

  statusPending: "In attesa di conferma",
  statusConfirmed: "Confermata",
  statusCancelled: "Cancellata",
  statusCompleted: "Completata",
  statusNoShow: "Assente",
  statusCancelledByEstablishment: "Cancellata dal ristorante",

  manageGoogleEventTitle: "Prenotazione presso {name}",
  manageGoogleDetailsIntro: "Prenotazione per {people}",
  manageGoogleDetailsCode: "Codice: {code}",
  manageGoogleDetailsNotes: "Note: {notes}",

  manageConfirmSuccessHeading: "Prenotazione confermata!",
  manageConfirmSuccessBody: "Ti aspettiamo il {date} alle {time}",
  manageAddToGoogleCalendar: "Aggiungi a Google Calendar",

  manageCancelSuccessHeading: "Prenotazione cancellata",
  manageCancelSuccessBodyLine1: "La tua prenotazione è stata cancellata.",
  manageCancelSuccessBodyLine2: "Speriamo di rivederti presto.",

  manageModifySuccessHeading: "Prenotazione modificata",
  manageModifySuccessBodyLine1: "La tua richiesta di modifica è stata inviata.",
  manageModifySuccessBodyLine2: "Riceverai una conferma a breve.",

  manageCancelledByRestaurantTitle:
    "Il ristorante ha cancellato questa prenotazione",
  manageCancelledByRestaurantBody:
    "Ci scusiamo per il disagio. Ti invitiamo a prenotare un altro giorno o a contattare direttamente il ristorante.",
  manageCancellationReasonLabel: "Motivo indicato dal ristorante",

  manageYourReservationHeading: "La tua prenotazione",
  manageRoomLabel: "Sala: {roomName}",
  manageCodeLabelBlock: "Codice prenotazione",
  manageNotesLabel: "Note",

  manageMenuHeading: "Il tuo menu",
  manageMenuChangeButton: "Cambia",
  manageMenuNoneSelected: "Non hai aggiunto nessun menu alla tua prenotazione.",
  manageMenuNotEditableNotice:
    "La scelta del menu può essere modificata fino al giorno prima della prenotazione.",
  manageMenuModalTitle: "Cambia menu",
  manageMenuSaveErrorFallback: "Errore nel salvataggio del menu",

  managePendingApprovalBannerTitle: "In attesa di approvazione del ristorante.",
  managePendingApprovalBannerBody:
    "Quando la confermerà riceverai un avviso e potrai ratificare la tua presenza da qui.",
  manageConfirmDisabledTitle:
    "Disponibile quando il ristorante approverà la tua richiesta",
  manageConfirmDisabledLabel: "Conferma presenza (in attesa di approvazione)",
  manageConfirmButton: "Conferma presenza",

  managePendingChangeBannerTitle:
    "Hai già una richiesta di modifica in attesa.",
  managePendingChangeBannerFooter:
    "Il ristorante la esaminerà e ti risponderà a breve.",
  managePendingChangeDisabledTitle:
    "Hai già una richiesta di modifica in fase di revisione",
  managePendingChangeDisabledLabel: "Richiesta di modifica in attesa",
  manageModifyButton: "Modifica prenotazione",
  manageCancelButton: "Cancella prenotazione",

  managePendingSummaryDate: "data: {date}",
  managePendingSummaryTime: "ora: {time}",
  managePendingSummaryPeople: "persone: {n}",

  manageWhatsAppButton: "Contatta via WhatsApp",

  manageModalConfirmTitle: "Conferma presenza",
  manageModalConfirmQuestion:
    "Confermi che sarai presente alla tua prenotazione presso {name}?",
  manageModalConfirmBack: "Indietro",
  manageModalConfirmSubmit: "Conferma",

  manageModalCancelTitle: "Cancella prenotazione",
  manageModalCancelWarningTitle: "Sei sicuro?",
  manageModalCancelWarningBody:
    "Questa azione non può essere annullata. Se cancelli, perderai la tua prenotazione presso {name}.",
  manageModalCancelKeep: "Mantieni",
  manageModalCancelSubmit: "Cancella",

  manageModalEditTitle: "Modifica prenotazione",
  manageModalEditDateLabel: "Data",
  manageModalEditTimeLabel: "Ora",
  manageModalEditPartyLabel: "Numero di persone",
  manageModalEditSummaryPrefix: "Nuova prenotazione:",
  manageModalEditSummaryAt: "alle",
  manageModalEditSummaryFor: "per",
  manageModalEditCancel: "Annulla",
  manageModalEditSubmit: "Salva modifiche",

  // ── ConfirmReservation.tsx (conferma da email/WhatsApp) ──────────────
  confirmLoading: "Conferma della tua prenotazione in corso...",
  confirmErrorHeading: "Impossibile confermare",
  confirmAlreadyCancelled: "Questa prenotazione è già stata cancellata.",
  confirmGenericErrorFallback: "Errore nella conferma della prenotazione",

  confirmAwaitingHeading: "In attesa di approvazione",
  confirmAwaitingBody:
    "La tua prenotazione è in attesa di approvazione da parte del ristorante. Quando la confermerà riceverai un avviso via email o WhatsApp e potrai riconfermarla da qui.",
  confirmCodeLabelInline: "Codice prenotazione:",

  confirmAlreadyHeading: "Prenotazione già confermata",
  confirmSuccessHeading: "Prenotazione confermata!",
  confirmAlreadyBody: "La tua prenotazione era già stata confermata in precedenza.",
  confirmSuccessBody: "Grazie per aver confermato la tua presenza.",
  confirmFooterText: "Ti aspettiamo. Buon appetito!",

  classesPickDay: "Scegli il giorno",
  classesWeekPrev: "Settimana precedente",
  classesWeekNext: "Settimana successiva",
  classesCountOne: "{n} lezione",
  classesCountOther: "{n} lezioni",
  classesNoClassesThisDay: "Nessuna lezione in questo giorno",
  classesSeatsLeft: "{n} posti su {total}",
  classesFull: "Completo",
  classesMinutes: "{n} min",
  classesTeacher: "Prof. {name}",
  classesPeople: "Persone",
  classesName: "Nome e cognome",
  classesEmail: "Email",
  classesPhone: "Telefono (facoltativo)",
  classesMarketing: "Voglio ricevere le novità di questa attività",
  classesSubmit: "Conferma prenotazione",
  classesSubmitting: "Prenotazione…",
  classesFieldsError: "Controlla nome ed email",
  classesOnlyLeft: "Restano solo {n} posti per questa lezione",
  classesFullNow:
    "La lezione si è appena riempita. Scegli un altro orario o giorno.",
  classesSuccessTitle: "Prenotazione confermata!",
  classesSuccessCode: "Codice di prenotazione",
  classesSuccessEmailSent:
    "Ti abbiamo inviato un'email con i dettagli e il link per gestire la tua prenotazione.",
  classesNewBooking: "Fai un'altra prenotazione",
  classesLoadError: "Impossibile caricare le informazioni. Riprova.",
  classesCompanyToggle:
    "Prenoto per conto di un'azienda (hotel, agenzia…)",
  classesCompanyName: "Nome dell'azienda o dell'hotel",
} satisfies Messages;

export default it;
